import React from 'react';
import { StringUtil } from '../../../components/utils/string-util/string-util';
import { PrimaryButton } from '../../../components/common';
import { ActivityIndicator } from '../../../components/common/activity-indicator/activity-indicator';
import { CampaignIdApiResponse } from '../../../services/recalls-service/recalls-service';
import { RecallsProps } from '../recalls/hook/use-recalls-content';
import { ExemptWordsListProps } from '../recalls/hook/use-exempt-word-list';

interface Props {
    recallsContent: RecallsProps;
    campaignDetails: CampaignIdApiResponse | null | undefined;
    loading: boolean;
    exemptWordsContent: ExemptWordsListProps | null | undefined;
    fields: any[];
    isCsp: boolean;
}

export const RecallsCampaignDetails = (props: Props) => {
    return (
        <>
            {!props.loading ? (
                <div
                    className="recalls-campaign-details-container"
                    data-testid="recalls-campaign-details"
                >
                    <h1 className="recalls-campaign-details-title">
                        {props.isCsp
                            ? props.recallsContent.campaignDetailsCspTitle
                            : props.recallsContent.campaignDetailsRecallTitle}
                    </h1>
                    {props.campaignDetails && (
                        <>
                            {!props.campaignDetails?.error &&
                            props.campaignDetails?.localFsaDescInEnglish ? (
                                <>
                                    <div className="recalls-campaign-name">
                                        {props.exemptWordsContent
                                            ? StringUtil.sentenceCase(
                                                  props.campaignDetails
                                                      ?.localFsaDescInEnglish,
                                                  props.exemptWordsContent
                                              )
                                            : props.campaignDetails
                                                  ?.localFsaDescInEnglish}
                                    </div>
                                    <hr className="recalls-separator" />
                                    {props.fields.map(field => {
                                        if (field.title && field.value)
                                            return (
                                                <div
                                                    className="recalls-campaign-field"
                                                    key={field.value}
                                                >
                                                    <div
                                                        className={`recalls-campaign-label`}
                                                    >
                                                        {field.title}
                                                    </div>
                                                    <div
                                                        className={`recalls-campaign-value`}
                                                    >
                                                        {props.exemptWordsContent
                                                            ? StringUtil.sentenceCase(
                                                                  field.value,
                                                                  props.exemptWordsContent
                                                              )
                                                            : field.value}
                                                    </div>
                                                </div>
                                            );
                                    })}
                                    <div className="find-a-dealer-button-container">
                                        <PrimaryButton
                                            color={'dark'}
                                            fill={'fill'}
                                            chevron={true}
                                            className="find-a-dealer-button"
                                            href={
                                                props.recallsContent
                                                    .findADealerButtonLink
                                            }
                                        >
                                            {
                                                props.recallsContent
                                                    .findADealerButtonText
                                            }
                                        </PrimaryButton>
                                    </div>
                                    {props.recallsContent
                                        .relatedTopicsContent && (
                                        <div className="recalls-related-topics">
                                            <h2 className="related-topics-title">
                                                {
                                                    props.recallsContent
                                                        .relatedTopicsTitle
                                                }
                                            </h2>
                                            <div
                                                className="recalls-related-topics-content"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        props.recallsContent
                                                            .relatedTopicsContent,
                                                }}
                                            />
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div
                                    className="no-campaign-error-message"
                                    data-testid="error-message"
                                >
                                    {
                                        props.recallsContent
                                            .campaignDetailsErrorMessage
                                    }
                                </div>
                            )}
                        </>
                    )}
                </div>
            ) : (
                <ActivityIndicator />
            )}
        </>
    );
};
